export const BONUS_POINT_ACTIVITY_TYPES = {
  close: 'Close issue',
  community_bonus: 'Community bonus',
  support: 'Community support',
  content: 'Content creation',
  event: 'Event activity',
  label: 'Label issue',
  social: 'Social engagement',
  other: 'Other',
};

export const DEFAULT_TITLE = 'GitLab Contributor Platform';

export const SUBMISSION_KINDS = {
  event: 'contributor_platform_event',
  content: 'contributor_platform_content',
};

export const SUBMISSION_KIND_LABELS = {
  [SUBMISSION_KINDS.event]: 'Event',
  [SUBMISSION_KINDS.content]: 'Content',
};

export const SUBMISSION_REVIEW_ACTIONS = {
  approve: 'approve',
  reject: 'reject',
};

export const EVENT_ROLE_OPTIONS = [
  { text: 'Speaker', value: 'speaker' },
  { text: 'Organizer', value: 'organizer' },
];

export const EVENT_FORMAT_OPTIONS = [
  { text: 'Virtual', value: true },
  { text: 'In-person', value: false },
];

export const EVENT_SIZE_OPTIONS = [
  { text: 'Small (< 20)', value: 'small' },
  { text: 'Medium (20 - 100)', value: 'medium' },
  { text: 'Large (100+)', value: 'large' },
];

const labelsFrom = options => Object.fromEntries(options.map(({ text, value }) => [value, text]));

export const EVENT_ROLE_LABELS = labelsFrom(EVENT_ROLE_OPTIONS);
export const EVENT_FORMAT_LABELS = labelsFrom(EVENT_FORMAT_OPTIONS);
export const EVENT_SIZE_LABELS = labelsFrom(EVENT_SIZE_OPTIONS);

export const REWARD_REASONS = {
  first_contribution: 'First contribution',
  hackathon: 'Hackathon',
  notable_contributor: 'Notable contributor (MVP)',
  level_up: 'Level up',
  other: 'Other',
};

export const LEVEL_POINTS = {
  5: 37_500,
  4: 7_500,
  3: 2_500,
  2: 500,
  1: 25,
  0: 0,
};

export const MAX_ASSIGNED_ISSUES_HARD_LIMIT = 100;

export const MAX_ASSIGNED_ISSUES_BY_LEVEL = {
  0: 4,
  1: 8,
  2: 12,
  3: 16,
};

export const MAX_ASSIGNED_ISSUES_BY_LABEL = {
};
